import { SyncOffIcon } from './SyncOffIcon';

/**
 * author: Google
 * id 538457F5-44DB-404B-92FE-5FB8597B258E
 * name sync-off
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sync-off.svg
 * tags
 */
export const SyncDisabledIcon = SyncOffIcon;
export default SyncDisabledIcon